// store/modules/user.js
import Cookies from "js-cookie";
import { apiGetUniq } from "@/api/user";

const state = {
  token: "",
  did: "",
  userInfo: {
    mobile: "",
    name: "",
    avatar: "",
    booth: [],
  },
  orderParam: [],
  sdCart: [],
  zjCart: [],
  jbCart: [],
};

const mutations = {
  SET_DID(state, did) {
    state.did = did;
    Cookies.set("did", did, { expires: 12 / 24 });
  },
  REMOVE_DID(state) {
    state.did = "";
    Cookies.remove("did");
  },
  SET_TOKEN(state, token) {
    state.token = token;
    Cookies.set("token", token, { expires: 12 / 24 });
  },
  REMOVE_TOKEN(state) {
    state.token = "";
    Cookies.remove("token");
  },
  SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
    Cookies.set("userInfo", JSON.stringify(userInfo), { expires: 12 / 24 });
  },
  SET_USERBOOTH(state, booth) {
    state.userInfo.booth = booth;
    Cookies.set("userInfo", JSON.stringify(state.userInfo), {
      expires: 12 / 24,
    });
  },
  REMOVE_USERINFO(state) {
    state.userInfo = {
      mobile: "",
      name: "",
      avatar: "",
      booth: [],
    };
    Cookies.remove("userInfo");
  },
  SET_ORDERPARAM(state, orderParam) {
    state.orderParam = orderParam;
    Cookies.set("orderParam", JSON.stringify(orderParam));
  },
  SET_SDCART(state, cart) {
    state.sdCart = cart;
    localStorage.setItem("sdCart", JSON.stringify(cart));
  },
  REMOVE_SDCART(state) {
    state.sdCart = [];
    localStorage.removeItem("sdCart");
  },
  SET_ZJCART(state, cart) {
    state.zjCart = cart;
    localStorage.setItem("zjCart", JSON.stringify(cart));
  },
  REMOVE_ZJCART(state) {
    state.zjCart = [];
    localStorage.removeItem("zjCart");
  },
  SET_JBCART(state, cart) {
    state.jbCart = cart;
    localStorage.setItem("jbCart", JSON.stringify(cart));
  },
  REMOVE_JBCART(state) {
    state.jbCart = [];
    localStorage.removeItem("jbCart");
  },
  INIT(state) {
    console.log("INIT");
    state.did = Cookies.get("did");
    state.token = Cookies.get("token");
    state.userInfo = Cookies.get("userInfo")
      ? JSON.parse(Cookies.get("userInfo"))
      : {
          mobile: "",
          name: "",
          avatar: "",
          booth: [],
        };
    state.orderParam = Cookies.get("orderParam")
      ? JSON.parse(Cookies.get("orderParam"))
      : [];
    state.sdCart = localStorage.getItem("sdCart")
      ? JSON.parse(localStorage.getItem("sdCart"))
      : [];
    state.zjCart = localStorage.getItem("zjCart")
      ? JSON.parse(localStorage.getItem("zjCart"))
      : [];
    state.jbCart = localStorage.getItem("jbCart")
      ? JSON.parse(localStorage.getItem("jbCart"))
      : [];
  },
};

const actions = {
  login({ commit }, data) {
    // 登录接口调用
    // ...
    commit("SET_TOKEN", data.token);
    commit("SET_USERINFO", data.userInfo);
  },
  async refreshDID({ commit }) {
    apiGetUniq().then((res) => {
      commit("SET_DID", res.data.did);
    });
  },
  async logout({ commit, dispatch }) {
    // 退出登录接口调用
    // ...
    console.log("退出登录");
    await dispatch("refreshDID");
    commit("REMOVE_TOKEN");
    commit("REMOVE_USERINFO");
    commit("exhibition/REMOVE_EXHIBITION", null, { root: true });
  },
};

const getters = {
  token: (state) => state.token,
  userInfo: (state) => state.userInfo,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
